import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 사용자 회원으로 push 전송
const USER_APP_ID = 'c114d82e-38e7-4b63-8725-b68aad44d409';
const USER_ANDROID_CHANNEL_ID = 'b0f6cc99-2155-4471-8eed-3bc4e35a4c7a';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  constructor(private httpClient: HttpClient) {}

  sendPush(pushIds: Array<string>, message: string, data?: any, header = '알라딘크린') {
    return new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };
      let payload = {
        app_id: USER_APP_ID,
        headings: { en: header },
        contents: { en: message },
        data,
        include_player_ids: pushIds,
        android_channel_id: USER_ANDROID_CHANNEL_ID,
      };
      if (pushIds.length > 0) {
        this.httpClient.post('https://onesignal.com/api/v1/notifications', payload, httpOptions).subscribe(
          (new_data) => {
            console.log('성공', new_data);
            resolve(new_data);
          },
          (error) => {
            console.log('에러', error);

            reject(error);
          }
        );
      } else {
        console.log('이거아니야?');

        resolve('');
      }
    });
  }
}
